
import Dictionary from "./Dictionary";
import "./App.css";

export default function App() {
  return (
    <div className="App mt-4 container-fluid">
      <header className="App-header mb-5 text-center">
       <h1 className="mb-4">Dictionary App</h1>
        <Dictionary />
        
      </header>
    </div>
  );
}
